import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {UserInfo} from '../types/user';
import * as Sentry from "@sentry/angular";

@Injectable({
    providedIn: 'root',
})
export class AuthStore {
    public noAuth: UserInfo = {
        user_type: 0,
        user_first_name: '',
        user_last_name: '',
        user_mail: '',
        id: '',
        group_id: '',
        group: null,
        user_status: 'active',
        created_at: new Date(),
        updated_at: new Date(),
        deleted_at: new Date()
    }

    private userInfoSubject: BehaviorSubject<UserInfo> = new BehaviorSubject<UserInfo>(this.noAuth);
    public initalRequest: boolean = false;

    constructor() {
        this.userInfoSubject.subscribe((val) => {
            Sentry.setUser({id: val.id});
        });
    }

    get userInfo(): UserInfo {
        return this.userInfoSubject.value;
    }

    set userInfo(userInfo: UserInfo) {
        this.initalRequest = true;
        this.userInfoSubject.next(userInfo);
    }

    get $userInfo(): Observable<UserInfo> {
        return new Observable((fn) => this.userInfoSubject.subscribe(fn));
    }

    clear() {
        this.userInfo = this.noAuth;
    }

    isLoggedIn(): boolean {
        return this.userInfo && this.userInfo.id !== '';
    }

    isUser(level: number): boolean {
        if (this.userInfo && this.userInfo.id !== '') {
            return this.userInfo.user_type >= level
        }
        return this.userInfo && this.userInfo.id !== '' && this.userInfo.user_type >= level
    }

}
